import { Component, OnInit, Inject } from '@angular/core';
import {
  MsalBroadcastService,
  MsalService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
  SilentRequest,
  RedirectRequest,
} from '@azure/msal-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { protectedResources } from '../../../../../../auth-config';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit {
  public accountDisplayName = '';

  public loggedinB2C = false;

  public constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalBroadcastService: MsalBroadcastService,
    private msalAuthService: MsalService,
    /*
     * private mandantConfigService: MandantConfigService,
     * public oauthService: OAuthService,
     * public authenticationService: AuthenticationService,
     */
    public router: Router,
    public activatedRoute: ActivatedRoute
  ) {}

  public OnLoginClick(_event: any) {
    /*
     *switch (environment.LoginButtonBehaviour) {
     *  case LoginBehaviour.Choice:
     *    this.router.navigate(['authentication', 'login']);
     *    break;
     *  case LoginBehaviour.B2C:
     *    this.router.navigate(['authentication', 'b2c']);
     *    break;
     *  case LoginBehaviour.Ciam:
     *    this.router.navigate(['authentication', 'ciam']);
     *    break;
     *  default:
     *    break;
     */
    // this.router.navigate(['authentication', 'login']);
    if (this.msalGuardConfig.authRequest) {
      this.msalAuthService.loginRedirect({
        ...this.msalGuardConfig.authRequest,
      } as RedirectRequest);
    } else {
      this.msalAuthService.loginRedirect();
    }
  }

  public OnLogoutClick(_event: any) {
    // this.authenticationService.doLogout();
    this.msalAuthService.logout();
    /*
     *   {
     *   postLogoutRedirectUri: `${window.location.origin}`,
     * }
     */
  }

  public ngOnInit(): void {
    this.setLoginDisplay();
    this.msalBroadcastService.msalSubject$
      .pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS))
      .subscribe((result: EventMessage) => {
        console.log('LOGIN SUCCESS:', result);

        const accessTokenRequest: SilentRequest = {
          scopes: [...protectedResources.filterGruppe.scopes],
          account: this.msalAuthService.instance.getAllAccounts()[0],
        };

        this.msalAuthService
          .acquireTokenSilent(accessTokenRequest)
          .toPromise()
          .then((value: AuthenticationResult) => {
            console.log('got AuthenticationResult via SilentRefresh:', value);
          });

        this.setLoginDisplay();
      });

    this.msalBroadcastService.inProgress$
      .pipe(filter((status: InteractionStatus) => status === InteractionStatus.None))
      .subscribe(() => {
        // console.log('loginstatus:', status);
        this.setLoginDisplay();
      });
  }

  public setLoginDisplay() {
    const accounts = this.msalAuthService.instance.getAllAccounts();
    if (accounts[0] != null) {
      this.loggedinB2C = true;
      this.accountDisplayName = `${accounts[0].name ?? 'login'}`;
    }
  }
}
